import FindActivitiesHeader from "./components/FindActivitiesHeader";
import ActivityList from "./components/ActivityList";
import Footer from "../components/Footer";
import CustomPagination from "../components/CustomPagination";
import { ActivityListProps } from "../interfaces/ActivityInterface";
import React, { useState } from "react";
import styles from "./styles/AllActivities.module.scss";
import ActivityDetailModal from "../components/ActivityDetailModal";

export default function AllActivities({ activities }: ActivityListProps) {
  const itemsPerPage = 9;
  const totalPages = Math.ceil(activities.length / itemsPerPage);
  const [activitiesOnCurrentPage, setActivitiesOnCurrentPage] = useState(
    activities.slice(0, itemsPerPage)
  );

  const [toggleActivityDetail, setToggleActivityDetail] = useState(1);
  const [showActivityDetail, setShowActivityDetail] = useState(activities[0]);

  function setActivityDetail(toggleStatus: number, id: string) {
    setToggleActivityDetail(toggleStatus);
    setShowActivityDetail(activities[parseInt(id) - 1]);
  }

  function handleChangePage(currentPage: number) {
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = currentPage * itemsPerPage;

    setActivitiesOnCurrentPage(activities.slice(startIndex, endIndex));
  }

  return (
    <div className={styles.activity_page}>
      <div
        className={styles.activity_modal}
        style={{ display: toggleActivityDetail ? "none" : "block" }}
      >
        <ActivityDetailModal
          closeModal={setActivityDetail}
          showActivityDetail={showActivityDetail}
        />
      </div>

      <FindActivitiesHeader></FindActivitiesHeader>
      <ActivityList
        activities={activitiesOnCurrentPage}
        setActivityDetail={setActivityDetail}
      ></ActivityList>
      <CustomPagination
        totalPages={totalPages}
        handleChangePage={handleChangePage}
        className={styles.pagination}
      ></CustomPagination>
      <Footer></Footer>
    </div>
  );
}
